import script from "./AnalysisJourneySection.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalysisJourneySection.vue?vue&type=script&setup=true&lang=js"

import "./AnalysisJourneySection.vue?vue&type=style&index=0&id=10c834ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c834ec"]])

export default __exports__